export default "__VITE_ASSET__BlRdMnyg__"